import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
//import { FaPlus } from "react-icons/fa6";
//import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

import "../daterangepicker.css";
import "../Usuarios/usuarios.css";
import "../../Forms.css";
//import buttonStyles from "../../../../styles/Button.module.css";
//import menuStyle from "../../../../styles/Menu.module.css";

import ChangeCreditLimitModal from "../LimitLevels/ChangeCreditLimitModal";
import ChangeLevelModal from "../LimitLevels/ChangeLevelModal";
//import TableOptionCheck, { FilterType } from "../Productos/TableOptionCheck";
//import SearchBar from "../SearchBar";
import CreateAsociados from "./CreateAsociados";

//import AsociadosKPITable from "./AsociadosKPITable";
import * as api from "helper/helper";
import { Sections } from "../../data/navItem";
import { PermissionsForSection } from "../auth";
import PagedFetch, {
  buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
//import FilterButton from "../FilterButton/FilterButton";
import AsociadosKPISmall from "./AsociadosKPISmall";
import AsociadosNuevosSmall from "./AsociadosNuevosSmall";

export default function AsociadosDashboard() {
  const createAsociadosRef = useRef();
  const changeCreditLimitRef = useRef();
  const changeLevelRef = useRef();

  const dateRangeRef = useRef();
  const dateRangeEleRef = useRef();

  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  /** FILTERS */
  const [kpiData, setKpiData] = useState([]);
  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({});
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  useEffect(() => {
    console.log("--->");

    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const daysBack7 = new Date(now);
    daysBack7.setDate(daysBack7.getDate() - 6);
    const daysBack30 = new Date(now);
    daysBack30.setDate(daysBack30.getDate() - 29);

    const thisMonthStart = new Date(now);
    thisMonthStart.setDate(1);
    const thisMonthEnd = new Date(thisMonthStart);
    thisMonthEnd.setMonth(thisMonthEnd.getMonth() + 1);
    thisMonthEnd.setDate(-1);

    const lastMonthStart = new Date(now);
    lastMonthStart.setDate(1);
    lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
    const lastMonthEnd = new Date(lastMonthStart);
    lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1);
    lastMonthEnd.setDate(-1);

    const lastYearStart = new Date(now);
    lastYearStart.setDate(1);
    lastYearStart.setMonth(0);
    lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);

    const lastYearEnd = new Date(lastYearStart);
    lastYearEnd.setFullYear(lastYearStart.getFullYear() + 1);
    lastYearEnd.setDate(-1);

    const sameMonthDifAge = new Date(now);
    sameMonthDifAge.setDate(sameMonthDifAge.getFullYear() - 1);

    dateRangeRef.current = new window.daterangepicker(
      dateRangeEleRef.current,
      {
        locale: {
          customRangeLabel: "Rango Personalizado",
        },
        singleDatePicker: false,
        showDropdowns: true,
        showCustomRangeLabel: true,

        minYear: 2020,
        maxYear: now.getFullYear(), // parseInt(moment().format('YYYY'),10)
        ranges: {
          Hoy: [now, now],
          Ayer: [yesterday, yesterday],
          "Ultimos 7 Dias": [daysBack7, now],
          "Ultimos 30 Dias": [daysBack30, now],
          "Este mes": [thisMonthStart, thisMonthEnd],
          "Ultimo mes": [lastMonthStart, lastMonthEnd],
          "Ultimo Año": [lastYearStart, lastYearEnd],
        },
      },
      function (start, end, label) {
        //  var years = 23; //moment().diff(start, 'years');
        //  alert("You are " + years + " years old!");
      },
    );

    /*

    $(function() {

        var start = moment().subtract(29, 'days');
        var end = moment();

        function cb(start, end) {
            $('#reportrange span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
        }

        $('#reportrange').daterangepicker({
            startDate: start,
            endDate: end,
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        }, cb);

        cb(start, end);

    });
    
    */
    /*
    .daterangepicker({
      timePicker: true,
      startDate: 22, //moment().startOf("hour"),
      endDate: 33, //moment().startOf("hour").add(32, "hour"),
      locale: {
        format: "M/DD hh:mm A",
      },
    });*/
    fetchData();

    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);
  }, []);

  const fetchData = async () => {
    let criteria = searchCriteria;
    /// reset pag info
    pagingInfoRef.current.resetPageInfo();

    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  };

  function reloadAsociados() {
    fetchData();
  }

  const searchFetchData = async (criteria) => {
    setIsLoading(true);

    const response = await api
      .asociadosKPIDataIntegrity(criteria)
      .catch((error) => {
        toast.error("Error al buscar Clientes.");
        setIsLoading(false);
      });
    if (!response) return;

    setKpiData(response.data.subset);

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    //  setAsociados(response.data.subset);

    setIsLoading(false);
  };

  return (
    <>
      <div className="">
        <div className="bd-example">
          <div className="container  overflow-hidden">
            <div className="row  gx-5">
              <div className="col">
                <AsociadosNuevosSmall />
              </div>

              <div
                className="col card1 recent-sales overflow-auto"
                style={{
                  backgroundColor: "transparent",
                  borderRadius: "0px",
                  marginBottom: "30px",
                }}
              >
                <AsociadosKPISmall />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card recent-sales overflow-auto">
        <div className="separator"></div>
      </div>
    </>
  );
}
